export const connectedApps = {
  totalApps: 26,
  totalFiles: 3000000,
  totalFilesSharingData: 2220000,
  totalFilesNotSharingData: 780000
}
